export enum LogWorkState {
    NONE = 'NONE',
    ERROR = 'ERROR',
    SUCCESS = 'SUCCESS',
    CANCELLED = 'CANCELLED'
  }